import { __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import { createTheme } from '@mui/material/styles';
import { linearProgressClasses } from '@mui/material';

var augmentColor = createTheme().palette.augmentColor;
var createColor = function (mainColor) { return augmentColor({ color: { main: mainColor } }); };
var createMuiTheme = function (_a) {
    var _b;
    var palette = _a.palette, mode = _a.mode, backgrounds = _a.backgrounds, fontFamily = _a.fontFamily, fontFamilyH1H6 = _a.fontFamilyH1H6, imageColorOverride = _a.imageColorOverride;
    return createTheme({
        palette: __assign(__assign({}, palette), { mode: mode, primary: createColor(palette.highlighted), secondary: createColor(palette.neutral300), danger: createColor(palette.red), success: createColor(palette.green), contrastThreshold: 3, tonalOffset: 0.2, backgrounds: backgrounds, imageColorOverride: imageColorOverride }),
        typography: __assign(__assign({ fontFamily: fontFamily.join(",") }, (fontFamilyH1H6 && {
            h1: { fontFamily: fontFamilyH1H6.join(",") },
            h2: { fontFamily: fontFamilyH1H6.join(",") },
            h3: { fontFamily: fontFamilyH1H6.join(",") },
            h4: { fontFamily: fontFamilyH1H6.join(",") },
            h5: { fontFamily: fontFamilyH1H6.join(",") },
            h6: { fontFamily: fontFamilyH1H6.join(",") },
        })), { button: {
                textTransform: "none",
            } }),
        components: {
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true,
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        border: "1px solid ".concat(palette.neutral600),
                        background: palette.neutral800,
                        color: palette.neutral200,
                    },
                },
            },
            MuiInput: {
                styleOverrides: {
                    root: "\n          border: 1px solid ".concat(palette.neutral600, ";\n          min-height: 60px;\n          border-radius: 5px;\n          display: flex;\n          align-items: center;\n          background: ").concat(backgrounds.neutralBg, ";\n          transition: border-color 0.2s;\n          \n          &.Mui-disabled {\n            cursor: not-allowed;\n            border-color: ").concat(palette.neutral700, ";\n          }\n      \n          &.Mui-focused,\n          &:hover {\n            border-color: ").concat(palette.neutral400, ";\n            &.Mui-disabled {\n              border-color: ").concat(palette.neutral700, ";\n            }\n          }\n          \n          &.Mui-error,\n          &.Mui-error:hover,\n          &.Mui-error.Mui-focused {\n            border-color: ").concat(palette.red, ";\n      \n            .MuiInputLabel-root {\n              color: ").concat(palette.neutral200, ";\n            }\n          }          \n          \n          .MuiInputAdornment-root {\n            .MuiSvgIcon-root {\n              width: 18px;\n              height: 18px;\n            }\n          }\n          \n          .MuiInput-input {\n            border: none;\n            color: ").concat(palette.neutral100, " !important;\n            outline: none;\n            font-weight: 400;\n            font-size: 16px;\n            &.MuiInputBase-inputSizeSmall{\n              font-size: 11px;\n              padding: 0;\n              line-height: 14px;\n            }\n            line-height: 20px;\n            letter-spacing: 0.55px;\n            width: 100%;\n            box-shadow: none !important;\n            resize: none;\n            -webkit-text-fill-color: ").concat(palette.neutral300, " !important;\n            // 1Password autofill fix\n            background: linear-gradient(90deg,").concat(backgrounds.neutralBg, " 0%,").concat(backgrounds.neutralBg, " 100%);\n          }\n          \n          .MuiInput-input {\n            &::placeholder {\n              -webkit-text-fill-color: ").concat(palette.neutral400, " !important;\n            }\n        \n            &.Mui-disabled {\n              cursor: not-allowed;\n              opacity: 0.67;\n              color: ").concat(palette.neutral100, " !important;\n            }\n        \n            &::-webkit-inner-spin-button,\n            &::-webkit-outer-spin-button {\n              -webkit-appearance: none;\n              margin: 0;\n            }\n          }\n           \n        "),
                },
            },
            MuiButtonGroup: {
                styleOverrides: {
                    root: {
                        "&": "\n          & > .MuiButton-root {\n            border-radius: 0;\n            &:first-child {\n              border-top-left-radius: 4px;\n              border-bottom-left-radius: 4px;\n            }\n            &:last-child {\n              border-top-right-radius: 4px;\n              border-bottom-right-radius: 4px;\n            }\n          }\n          \n          & > span .MuiButton-root {\n            border-radius: 0 !important;\n          }\n          \n          & > span:first-child .MuiButton-root {\n            border-radius: 4px 0 0 4px !important;\n          }\n          \n          & > span:last-child .MuiButton-root {\n            border-radius: 0 4px 4px 0 !important;\n          }\n        ",
                    },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    root: "\n            background: ".concat(backgrounds.header, ";\n            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\n            display: flex;\n            align-items: center;\n            flex-direction: row;\n            &, .MuiToolbar-root {\n              min-height: 52px;\n            }\n            border: none;\n            z-index: 12;\n          "),
                },
            },
            MuiLinearProgress: {
                styleOverrides: {
                    root: (_b = {
                            backgroundColor: "rgb(19,28,53)",
                            borderRadius: 9,
                            height: 18,
                            "&:before": {
                                content: "''",
                                position: "absolute",
                                zIndex: 2,
                                borderRadius: 9,
                                padding: "3px",
                                background: "linear-gradient(90deg, #7319DB, #05EAC1)",
                                mask: "linear-gradient(#fff 0 0, #fff 0 0), content-box, linear-gradient(#fff 0 0, #fff 0 0)",
                                WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                                WebkitMaskComposite: "destination-out",
                                maskComposite: "exclude",
                                outline: "solid 2px rgb(19,28,53)",
                                outlineOffset: "-4px",
                                inset: "-1px",
                            }
                        },
                        _b["& .".concat(linearProgressClasses.bar)] = {
                            borderRadius: 7,
                            inset: "2px",
                            width: "calc(100% - 4px)",
                            backgroundImage: "linear-gradient(90deg, #7319DB, #05EAC1)",
                        },
                        _b),
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        color: palette.neutral300,
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 5,
                        "&&": {
                            display: "inline-flex",
                        },
                        ".MuiButton-startIcon, .MuiButton-endIcon": {
                            lineHeight: 1,
                            verticalAlign: "middle",
                        },
                    },
                    plain: {
                        padding: "0 !important",
                        ".MuiSvgIcon-root": {
                            fill: palette.neutral300,
                            transition: "all .2s",
                        },
                        "&:hover": {
                            background: "none",
                        },
                        "&:hover .MuiSvgIcon-root": {
                            fill: palette.neutral100,
                        },
                        "&.Mui-disabled:hover .MuiSvgIcon-root": {
                            fill: palette.neutral300,
                        },
                        "&.Mui-disabled": {
                            opacity: 0.33,
                            cursor: "not-allowed",
                        },
                    },
                    sizeXlarge: {
                        minHeight: "60px",
                        minWidth: "127px",
                        fontSize: "16px",
                        lineHeight: "20px",
                        letterSpacing: "1.1px",
                        fontWeight: 600,
                        padding: "10px 36px",
                        ".MuiButton-startIcon": {
                            marginLeft: "-6px",
                        },
                    },
                    sizeLarge: {
                        minHeight: "48px",
                        minWidth: "110px",
                        fontWeight: 600,
                        fontSize: "13px",
                        lineHeight: "18px",
                        paddingLeft: "30px",
                        letterSpacing: "1.1px",
                        paddingRight: "30px",
                        ".MuiButton-startIcon": {
                            marginLeft: "-4px",
                        },
                    },
                    sizeMedium: {
                        minHeight: "36px",
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        letterSpacing: "0.55px",
                        minWidth: "76px",
                        fontSize: "11px",
                        paddingLeft: "18px",
                        paddingRight: "18px",
                    },
                    sizeSmall: {
                        minHeight: "30px",
                        minWidth: "76px",
                        padding: "4px 18px",
                        letterSpacing: "0.55px",
                        fontSize: "11px",
                    },
                    containedSizeSmall: {
                        letterSpacing: "1.1px",
                    },
                    containedSizeMedium: {
                        letterSpacing: "1.1px",
                    },
                    text: {
                        color: palette.links,
                        fontWeight: "400 !important",
                        display: "inline",
                        padding: "0 2px !important",
                        borderRadius: "2px",
                        fontSize: "13px !important",
                        minWidth: "0 !important",
                        verticalAlign: "baseline",
                        minHeight: "0px !important",
                        ".MuiLoadingButton-loadingIndicatorCenter": {
                            transform: "translate(-50%, 50%)",
                            marginTop: "-4px",
                        },
                        "&:hover": {
                            background: "transparent",
                            textDecoration: "underline",
                        },
                        ".MuiButton-startIcon": {
                            marginRight: "5px",
                        },
                        ".MuiButton-endIcon": {
                            marginLeft: "5px",
                        },
                        ".MuiButton-startIcon, .MuiButton-endIcon": {
                            position: "relative",
                            display: "inline",
                            top: "-1px",
                            ".MuiSvgIcon-root": {
                                fill: palette.neutral300,
                                verticalAlign: "middle",
                            },
                        },
                    },
                    contained: {
                        "&, &:hover": {
                            boxShadow: "0px 12px 16px -8px rgba(25, 25, 39, 0.36)",
                        },
                        transition: "all 0.3s linear",
                        fontWeight: 600,
                        letterSpacing: "1.1px",
                        textTransform: "uppercase",
                        ".MuiTypography-root": {
                            textTransform: "none",
                        },
                        position: "relative",
                        overflow: "hidden",
                        zIndex: 1,
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: 0,
                            zIndex: -1,
                            height: "100%",
                            background: "rgba(0, 0, 0, .1)",
                            transition: "width 0.5s",
                        },
                        "&:hover::before, &.MuiButton-active::before": {
                            width: "100%",
                        },
                        "&.Mui-disabled": {
                            opacity: 0.33,
                        },
                    },
                    containedPrimary: {
                        ".MuiTypography-root": {
                            textTransform: "none",
                        },
                        color: palette.neutral000,
                        background: backgrounds.buttonPrimary,
                        ".MuiButton-startIcon": {
                            color: palette.neutral175,
                            "& svg.zig-icon": {
                                fill: palette.neutral175,
                            },
                        },
                    },
                    outlined: {
                        transition: "all 0.2s linear",
                    },
                    outlinedSecondary: {
                        borderColor: palette.neutral600,
                        color: palette.neutral300,
                        "&.MuiButton-sizeLarge, &.MuiButton-sizeXlarge": {
                            textTransform: "uppercase",
                            ".MuiTypography-root": {
                                textTransform: "none",
                            },
                        },
                        "&:hover, &.MuiButton-active": {
                            color: palette.neutral000,
                            borderColor: palette.neutral400,
                        },
                    },
                },
            },
            MuiTypography: {
                variants: [
                    {
                        props: { variant: "bigNumber" },
                        style: {
                            fontSize: "26px",
                            lineHeight: "40px",
                            color: palette.neutral100,
                            fontWeight: "500",
                        },
                    },
                ],
                defaultProps: {
                    variantMapping: {
                        h1: "h1",
                        h2: "h2",
                        h3: "h3",
                        h4: "h4",
                        body1: "span",
                        body2: "span",
                        caption: "span",
                    },
                },
                styleOverrides: {
                    root: {
                        letterSpacing: "0.55px",
                        color: palette.neutral100,
                    },
                    bigNumber: {
                        fontSize: "26px",
                        lineHeight: "40px",
                        fontWeight: "500",
                    },
                    h1: {
                        fontSize: "22px",
                        lineHeight: "36px",
                        marginBottom: "6px",
                        fontWeight: "500",
                    },
                    h2: {
                        fontSize: "18px",
                        lineHeight: "28px",
                        fontWeight: "500",
                    },
                    h3: {
                        fontSize: "15px",
                        lineHeight: "24px",
                        fontWeight: "500",
                    },
                    h4: {
                        fontSize: "13px",
                        lineHeight: "20px",
                        fontWeight: "500",
                    },
                    h5: {
                        fontSize: "11px",
                        lineHeight: "16px",
                        fontWeight: "500",
                    },
                    caption: {
                        fontSize: "11px",
                        lineHeight: "16px",
                        color: palette.neutral200,
                    },
                    body1: {
                        fontSize: "15px",
                        lineHeight: "24px",
                        color: palette.neutral200,
                    },
                    body2: {
                        fontSize: "13px",
                        lineHeight: "20px",
                        color: palette.neutral300,
                    },
                },
            },
            MuiLink: {
                styleOverrides: {
                    root: {
                        cursor: "pointer",
                        color: palette.links,
                    },
                },
            },
            MuiSlider: {
                styleOverrides: {
                    rail: {
                        backgroundColor: palette.neutral500,
                        opacity: 1,
                    },
                    mark: {
                        color: palette.neutral300,
                        backgroundColor: "currentcolor",
                        width: "4px",
                        height: "4px",
                        borderRadius: "50%",
                    },
                    thumb: {
                        color: palette.paleBlue,
                        width: "17px",
                        height: "17px",
                    },
                    track: {
                        color: palette.paleBlue,
                    },
                },
            },
        },
    });
};
var overrideTheme = function (base, override) {
    var _a;
    if (!override)
        return base;
    var result = {};
    for (var _i = 0, _b = Object.keys(base); _i < _b.length; _i++) {
        var k = _b[_i];
        if (typeof base[k] === "object" && !Array.isArray(base[k])) {
            result[k] = overrideTheme(base[k], override[k]);
        }
        else {
            result[k] = (_a = override[k]) !== null && _a !== void 0 ? _a : base[k];
        }
    }
    return result;
};
var getMuiTheme = function (baseTheme, overrides) {
    var overriden = baseTheme;
    for (var _i = 0, _a = overrides || []; _i < _a.length; _i++) {
        var k = _a[_i];
        overriden = overrideTheme(overriden, k || {});
    }
    return createMuiTheme(overriden);
};

export { getMuiTheme };
